import dayjs, { Dayjs } from 'dayjs';
import updateLocale from 'dayjs/plugin/updateLocale';
import relativeTime from 'dayjs/plugin/relativeTime';
import localizedFormat from 'dayjs/plugin/localizedFormat';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import vi from 'dayjs/locale/vi';

dayjs.extend(updateLocale);
dayjs.extend(localizedFormat);
dayjs.extend(relativeTime);
dayjs.extend(customParseFormat);

dayjs.locale(vi);

dayjs.updateLocale('vi', {
    relativeTime: {
        future: '%s nữa',
        past: '%s',
        s: 'vài giây',
        m: '1 phút',
        mm: '%d phút',
        h: '1 giờ',
        hh: '%d giờ',
        d: '1 ngày',
        dd: '%d ngày',
        M: '1 tháng',
        MM: '%d tháng',
        y: '1 năm',
        yy: '%d năm',
    },
    formats: {
        LT: 'HH:mm',
        LTS: 'HH:mm:ss',
        L: 'DD/MM/YYYY',
        LL: 'D MMMM [năm] YYYY',
        LLL: 'D MMMM [năm] YYYY HH:mm',
        LLLL: 'dddd, D MMMM [năm] YYYY HH:mm',
        l: 'dd',
        ll: 'D MMM YYYY',
        lll: 'dddd, DD/MM/YYYY',
        llll: 'dddd, D/M/YYYY HH:mm [(GMT+7)]',
    },
});

export const getLocalTime = (time: number): string => {
    if (!time) return '';
    const date = dayjs.unix(time);
    return date.format();
};

export const formatISOStr = (time: number): string => {
    return dayjs(time * 1000).toISOString();
}

export const formatTime = (time: number, text: string = ''): string => {
    const date = dayjs.unix(time);
    const now = dayjs();
    const duration = now.diff(date, 'day');
    if (duration > 0) {
        return date.format('DD/M/YYYY');
    }

    return dayjs.unix(time).fromNow() + text;
};

export const formatFullTime = (time: number): string => {
    return dayjs.unix(time).format('llll');
};

export const formatLocale = (time: number, format = 'llll'): string => {
    return dayjs.unix(time).format(format);
};

export const formatDate = (
    date: string,
    format: string = 'DD-MM-YYYY'
): string => {
    return dayjs(date).format(format);
};

export const formatFromCustomStr = (
    time: string,
    fromFormat: string,
    toFormat: string,
): string => {
    if (typeof time !== 'string' || !time) return '';

    return dayjs(time, fromFormat).format(toFormat);
};

export const getDay = (time: string) => {
    const timeObj = dayjs(time);
    const dayOfWeek = timeObj.day() + 1;
    const day = dayOfWeek === 1 ? 'Chủ nhật' : 'Thứ ' + dayOfWeek;

    return day;
};

export function parseDDMMYYY(date: number, format = 'YYYYMMDD'): Date {
    if (!dayjs(date.toString(), format).isValid()) {
        return new Date();
    }

    return dayjs(date.toString(), format).toDate();
}

export const getCurrentDate = (): string => {
    return dayjs().format('D');
}

export const getCurrentDayOfWeek = (): string => {
    return dayjs().format('dddd');
}

export const getCurrentMonth = (): string => {
    return dayjs().format('MMMM');
}

export const unixToDate = (unix?: number, format: string = 'HH:mm') => {
    if (!unix || unix < 0) {
        return '';
    }
    return dayjs(unix * 1000).format(format);
};

export function processDate(date: string | null, activeTab: string) {
    const now = dayjs().toDate();
    const dateObj = date ? dayjs(date, 'YYYYMMDD').toDate() : now;

    let from: Dayjs;
    let to: Dayjs;
    let dayBefore: number = 0;
    let dayAfter: number = 0;
    let daysInMonth: number = 0;

    switch (activeTab) {
        case 'week':
            from = dayjs(dateObj).startOf('week');
            to = dayjs(dateObj).endOf('week');
            break;
        case 'month':
            const _from = dayjs(dateObj).startOf('month');
            const _to = dayjs(dateObj).endOf('month');
            daysInMonth = _from.daysInMonth();
            dayBefore = _from.day() - 1 >= 0 ? _from.day() - 1 : 6;
            dayAfter =
                35 - (dayBefore + daysInMonth) > 0
                    ? 35 - (dayBefore + daysInMonth)
                    : 0;
            from = _from.subtract(dayBefore, 'days');
            to = _to.add(dayAfter, 'days');
            break;
        default:
            from = dayjs(dateObj);
            to = dayjs(dateObj);
            break;
    }

    return {
        fromDay: from,
        toDay: to,
        dayBefore,
        dayAfter,
        daysInMonth,
        dateObj,
    };
}
